import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  SvgIcon,
} from '@material-ui/core';
import { Menu as MenuIcon, X } from 'react-feather';
import Logo from 'components/Logo';
import THEMES from 'constantes/theme';
import Account from './Account';
// import Notifications from './Notifications';
// import Search from './Search';
import Settings from './Settings';
import CentroAyuda from './CentroAyuda';
import ShoppingCart from './ShoppingCart';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...theme.name === THEMES.LIGHT ? {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main,
    } : {},
    ...theme.name === THEMES.ONE_DARK ? {
      backgroundColor: theme.palette.background.default,
    } : {},
  },
  toolbar: {
    minHeight: 64,
  },
  logo: {
    width: 100,
  }
}));

function TopBar({
  className,
  onMobileNavOpen,
  isMobileNavOpen,
  fetchPermissions,
  permissions,
  thumbnail,
  ...rest
}) {
  const classes = useStyles();

  useEffect(() => {
    if (permissions.length === 0) {
      fetchPermissions();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <AppBar
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        {/* Pantalla grande */}
        <Hidden lgUp>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <SvgIcon fontSize="small">
              {isMobileNavOpen ? (<X />) : (<MenuIcon />)}
            </SvgIcon>
          </IconButton>
          <RouterLink to="/">
            <Logo />
          </RouterLink>
        </Hidden>
        {/* Pantalla Mediana */}
        <Hidden mdDown>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <SvgIcon fontSize="small">
              {isMobileNavOpen ? (<X />) : (<MenuIcon />)}
            </SvgIcon>
          </IconButton>
          <RouterLink to="/">
            <Logo
              className={classes.logo}
            />
          </RouterLink>
        </Hidden>
        <Box
          ml={2}
          flexGrow={1}
        />
        <ShoppingCart />
        {/* <Search /> */}
        <CentroAyuda />
        {/* <Notifications /> */}
        <Settings />
        <Box ml={2}>
          <Account
            thumbnail={thumbnail}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
  isMobileNavOpen: PropTypes.bool,
  fetchPermissions: PropTypes.func,
  permissions: PropTypes.arrayOf(PropTypes.string),
  thumbnail: PropTypes.string,
};

export default TopBar;
